var _circle, _line, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_10083_176",
    "data-name": "Component 10083 \\u2013 176",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 8,
    viewBox: "0 0 35 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1845",
    "data-name": "Ellipse 1845",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(24)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_1216",
    "data-name": "Line 1216",
    x2: 35,
    transform: "translate(0 4.5)",
    fill: "none",
    stroke: "#1F6ECD",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1846",
    "data-name": "Ellipse 1846",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(14)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1847",
    "data-name": "Ellipse 1847",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleTimeline);
export default __webpack_public_path__ + "static/media/single-timeline.acb10be5438437def962bb9b3f4bd942.svg";
export { ForwardRef as ReactComponent };